import { Button, List, Typography, Box, FormControl, TextField, Select, MenuItem, ListItem, Pagination, Tooltip, Autocomplete, Dialog, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { AddBusinessQuestions, AddTemplateQuestions, AddVenueQuestions, ApiGetQuestionUsage, GetCategories, GetQuestions } from '../../../apiService/Core/Apicall.tsx';
import { CancelOutlined, Info, SearchOutlined } from '@mui/icons-material';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from 'react-router-dom';

const limit = 20;
function QuestionList({ venueId, entityTypeTemplateId, clientEntityId, onUpdate }) {
    const [category, setcategorey] = useState<any>([])
    const [selectedCategory, setselectedCategory] = useState<number | string>(0)
    const [questionBank, setquestionBank] = useState<any>([])
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [openQuestionUsage, setOpenQuestionUsage] = useState<boolean>(false)
    const [questionUsageList, setQuestionUsageList] = useState<any>([])

    useEffect(() => {
        const fetchcategory = async () => {
            try {
                const categories = await GetCategories()
                setcategorey(categories.data)
            }
            catch (error) {
                toast.error(error)
            }
        }

        fetchcategory()
    }, [])
    useEffect(() => {
        const fetchquestionbank = async () => {
            const offset = (currentPage - 1) * limit;
            try {
                const response = await GetQuestions(offset, limit, 0, selectedCategory, searchTerm)
                setquestionBank(response.data)
                setTotal(response.totalCount);
                console.log(response.data)

            }
            catch (error) {
                toast.error(error)
            }
        }
        fetchquestionbank()
    }, [currentPage, selectedCategory, searchTerm])

    const totalPages = Math.ceil(total / limit);

    const filteredQuestions = questionBank
    // .filter((q) =>
    //     q.questions.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    const addData = async (questionId) => {
        if (clientEntityId === null) {

            const values = {
                entityTypeTemplateId: entityTypeTemplateId,
                questions: [{ questionId: questionId }]
            }
            // console.log("Values", values)
            try {
                const response = await AddTemplateQuestions(values)
                // alert(response.message)
                onUpdate()
            }
            catch (error) {
                toast.error(error)
            }

        }
        else {
            if (venueId === null) {
                const data = {
                    clientEntityId: clientEntityId,
                    questionId: questionId,
                    createdBy: Number(localStorage.getItem('createdBy')),
                }
                // console.log(data)
                try {
                    const response = await AddBusinessQuestions(data)
                    // alert(response.message)
                    onUpdate()
                }
                catch (error) {
                    toast.error(error)
                }
            }
            else {
                const data = {
                    venueId: venueId,
                    questionId: questionId,
                    createdBy: Number(localStorage.getItem('createdBy')),
                }
                // console.log(data)
                try {
                    const response = await AddVenueQuestions(data)
                    // alert(response.message)
                    onUpdate()
                }
                catch (error) {
                    toast.error(error)
                }

            }

        }

    }
    function decodeHtml(html) {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }

    const getQuestionUsage = async (questionId: number | string) => {
        try {
            const data = `?questionId=${questionId}`
            const res = await ApiGetQuestionUsage(data)
            if (res?.status) {
                setQuestionUsageList(res?.data)
                setOpenQuestionUsage(true)
            }
        } catch (error: any) {
            toast.error(error?.messsage)
        }
    }


    return (
        <Box className='w-100' maxHeight='100%' overflow='auto'>
            <Typography className='fs-18 fw-bold mb-2 mt-1'>Question Bank</Typography>
            <Box className='d-flex'>
                <FormControl className='mr-2' fullWidth>
                    <TextField
                        value={searchTerm ?? ""}
                        onChange={(e) => { setSearchTerm(e.target.value) }}
                        placeholder='Search Your Question here...'
                        InputProps={{ startAdornment: (<SearchOutlined />) }}
                    />
                </FormControl>
                <FormControl className='col-2'>
                    {/* <Select value={selectedCategory}
                        onChange={(e) => { setselectedCategory(Number(e.target.value)) }}>

                        <MenuItem value={0}>Select Category</MenuItem>
                        {category.length > 0 &&
                            category.map((cat, index) => (
                                <MenuItem value={cat.categoryId} key={index}>
                                    {cat.categoryName}
                                </MenuItem>
                            ))
                        }
                    </Select> */}

                    <Autocomplete
                        size="small"
                        options={category || []}
                        getOptionLabel={(option) => option.categoryName || ""}
                        isOptionEqualToValue={(option, value) =>
                            option.categoryId === value.categoryId
                        }
                        value={
                            category?.find(
                                (item) => item.categoryId === selectedCategory
                            ) || null
                        }
                        onChange={(event, newValue) => {
                            setselectedCategory(
                                newValue ? Number(newValue.categoryId) : 0
                            );
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                padding: "0px",
                                minHeight: "32px",
                            },
                            "& .MuiAutocomplete-input": {
                                padding: "6px 8px !important",
                            },
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                placeholder="Select Category"
                                InputLabelProps={{ shrink: undefined }}
                            />
                        )}
                        fullWidth
                    />
                </FormControl>
            </Box>
            {filteredQuestions.length > 0 && filteredQuestions.map((question, index) => (
                <Box key={index} className='my-2' border='1px solid #E0E0E0' borderRadius='5px' padding='10px'>
                    <Box className='d-flex justify-content-end'>
                        <Button className='px-4 py-1 bg-grey col-2 transform text-light' onClick={() => { addData(question.questionId) }}>+ Add</Button>
                    </Box>
                    <Box className='d-flex align-items-center justify-content-between my-3'>
                        <Box className='d-flex align-items-center flex-wrap' gap={1}>
                            <Typography className='text-main fw-bold'>Question ID: #{question.questionId}</Typography>
                            <Typography className='text-main fw-bold'>|</Typography>
                            <Typography className='fw-bold'>Category: {question.categoryId.categoryName}</Typography>
                            <Typography className='fw-bold'>|</Typography>
                            <Typography className='fw-bold'>Type: {question.qType.length > 0 ? question.qType === "R" ? "Radio" : question.qType === "r" ? 'Radio Rating' : question.qType === "C" ? 'CheckBox' : "Text" : 'notFound'}</Typography>
                            <Typography className='fw-bold'>|</Typography>
                            <Typography className="d-flex align-items-center" gap={1} sx={{ fontWeight: 'bold' }}>color: <Box height='20px' width='50px' bgcolor={question.colorHex} className="border"> </Box></Typography>

                        </Box>
                        <Button onClick={() => { getQuestionUsage(question.questionId) }} className="link-btn whitespace text-white" sx={{ textTransform: 'none' }}>
                            Usage
                        </Button>
                    </Box>
                    <Box>
                        <Typography className='fw-bold my-1 d-flex'>Q:&nbsp;<span dangerouslySetInnerHTML={{ __html: question.questions }} /></Typography>
                        <Box className='d-flex align-items-center' gap={3}>
                            <Box className='d-flex align-items-center'>
                                {/* <Box className='px-4 py-1 text-main' borderRight='1px solid #747247' bgcolor='#7472471A'>
                                    <Typography>Ver {question.verNo}</Typography>
                                </Box> */}
                                <Typography className='px-4 my-2 py-1 text-main bg-light-primary'>{question?.entityTypeId && question.entityTypeId.entityTypeName || 'undefined'}</Typography>
                            </Box>
                            <Box className=" bg-light-primary px-4 py-2" borderRadius='20px' width='fit-content'>
                                <Typography>{question.questionGroup}</Typography>
                            </Box>
                            {question.isPhotoRequire && (
                                <Box className=" bg-light-primary px-4 py-2" borderRadius='20px' width='fit-content'>
                                    <Typography>Images - Min: {question.minPhoto}</Typography>
                                </Box>
                            )}
                        </Box>
                        {question.qOptionJson !== null && question.qOptionJson.trim() !== "" ? (
                            <List component='ol' className="question-options w-100 d-flex justify-content-between flex-wrap">
                                {(() => {
                                    try {
                                        const parsedOptions = JSON.parse(question.qOptionJson);
                                        return parsedOptions.map((option, index) => (
                                            <ListItem key={index} className="col-6 option-text">
                                                <span>{index + 1}. &nbsp;</span>
                                                <span dangerouslySetInnerHTML={{ __html: option.value }} /> &nbsp;
                                                <span>(<span dangerouslySetInnerHTML={{ __html: option.optionScore }} />)</span>
                                                {option.radioRatingComment && (
                                                    <span className="ml-1">({option.radioRatingComment})</span>
                                                )}
                                                <Tooltip
                                                    title={
                                                        <Box>
                                                            <Typography variant='caption' display={'block'}><b>optionComment: </b> {option?.optionComment}</Typography>
                                                            <Typography variant='caption' display={'block'}><b>minChar: </b> {option?.minChar}</Typography>
                                                            <Typography variant='caption' display={'block'}><b>optionCommentType: </b> {option?.optionCommentType ?? "N/A"}</Typography>
                                                            {option?.optionImage && (<Typography variant='caption' display={'block'}><b>optionImage: </b> {option?.optionImage}</Typography>)}
                                                        </Box>
                                                    }
                                                >
                                                    <Info sx={{ fontSize: '16px', marginLeft: "8px" }} />
                                                </Tooltip>
                                            </ListItem>
                                        ));
                                    } catch (error) {
                                        console.error("Invalid JSON in qOptionJson:", error);
                                        return (
                                            <Typography className="option-text text-danger">
                                                Error: Invalid JSON format
                                            </Typography>
                                        );
                                    }
                                })()}
                            </List>
                        ) : (
                            <Typography className="option-text">
                                {question.options ? question.options[0] : "Answer will be a manual Text Entry."}
                            </Typography>
                        )}
                        <Typography className="d-flex">
                            Description: &nbsp;<span dangerouslySetInnerHTML={{ __html: decodeHtml(question.questionDescription) }} />
                        </Typography>
                        <Typography className="d-flex">
                            Hint: &nbsp;<span dangerouslySetInnerHTML={{ __html: decodeHtml(question.questionHint) }} />
                        </Typography>
                    </Box>
                </Box>
            ))}
            <Pagination
                className="d-flex justify-content-center"
                count={totalPages}
                page={currentPage}
                onChange={(event, value) => setCurrentPage(value)} // Page change handler
            />

            <Dialog fullWidth open={openQuestionUsage}>
                <Box className='d-flex align-items-center justify-content-between p-3'>
                    <Typography className="fw-bold" variant="h5">Question Usage</Typography>
                    <IconButton onClick={() => { setOpenQuestionUsage(false); setQuestionUsageList([]); }}>
                        <CancelOutlined />
                    </IconButton>
                </Box>
                <Box className='p-3'>
                    {questionUsageList?.businessUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Businesses</Typography>
                            <List sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.businessUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item !important", listStyle: 'outside', py: 0 }}>
                                            <Link
                                                to={`/admin/create-client-template/${item?.clientEntityId}`}
                                                // className="table-row-background fs-14 link-btn"
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"
                                            > {item?.entityName}
                                            </Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}

                    {questionUsageList?.venueUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Sites</Typography>
                            <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.venueUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                                            <Link
                                                to={`/admin/create-venue-site-template/${item?.venueId}`}
                                                // onClick={() => navigateToVenueSiteQuestion(venue)}
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"
                                            >
                                                {item?.venueName}
                                            </Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}
                    {questionUsageList?.templateUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Question Template</Typography>
                            <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.templateUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                                            <Link to={`/admin/create-new-template/${item?.templateName}/${item?.entityTypeTemplateId}`}
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"

                                            >
                                                {item?.templateName}</Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}
                </Box>
            </Dialog>
        </Box>
    )
}

export default QuestionList
